module.exports = __webpack_public_path__ + "static/media/main_nav_check_white.aec4d697.svg";